export default __webpack_public_path__ + "static/media/github.a590e476.png";